import { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

type SpinnerProps = ComponentProps<'svg'> & {
  statusText?: string;
};

const Spinner = ({
  className,
  statusText = 'Loading',
  ...props
}: SpinnerProps) => (
  <div
    data-slot="item-media"
    data-variant="default"
    className={cn(
      'tw-group-has-data-[slot=item-description]/item:tw-translate-y-0.5 tw-group-has-data-[slot=item-description]/item:tw-self-start tw-flex tw-shrink-0 tw-items-center tw-justify-center [&_svg]:tw-pointer-events-none tw-bg-transparent',
      className,
    )}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="tw-size-[38px] tw-animate-[spin_0.75s_linear_infinite]"
      role="status"
      aria-label={statusText}
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
    <span className="sr-only">{statusText}</span>
  </div>
);

export { Spinner };
